function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "37.358%",
  y1: "33.027%",
  x2: "96.435%",
  y2: "100%",
  id: "angsuran_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8E59",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD3A52",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "45.834%",
  x2: "100%",
  y2: "62.273%",
  id: "angsuran_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8E59",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD3A52",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.387%",
  y1: "39.264%",
  x2: "31.249%",
  y2: "102.206%",
  id: "angsuran_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCAB0",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB5BE",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "61.563%",
  y1: "-19.208%",
  x2: "61.563%",
  y2: "73.831%",
  id: "angsuran_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8E59",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD3A52",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "61.563%",
  y1: "-19.208%",
  x2: "61.563%",
  y2: "73.831%",
  id: "angsuran_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8E59",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD3A52",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.452 43.847h3.625a5.23 5.23 0 001.716-.278c14.591-5.084 2.36-31.106-4.337-34.152a2.489 2.489 0 00-1.032-.202h-8.916a2.679 2.679 0 00-1.212.284c-6.729 3.389-18.644 29.028-4.172 34.07.55.19 1.134.276 1.716.276h12.61l.002.002z",
  fill: "url(#angsuran_svg__a)",
  transform: "matrix(-1 0 0 1 33.917 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.838 9.244s2.723-4.027 4.054-5.8c1.331-1.78-3.552-2.221-5.328-.89 0 0-1.331-2.221-3.108-2.221h-.66c-1.777 0-3.108 2.22-3.108 2.22-1.777-1.33-6.661-.888-5.328.891 1.33 1.775 4.054 5.8 4.054 5.8h9.424z",
  fill: "url(#angsuran_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.55 26.47h.56c1.044 0 1.566-.462 1.566-1.387 0-.76-.512-1.144-1.536-1.144h-.59v2.53zm0 2.248v4.027H8.56V21.677h3.626c3.008 0 4.511 1.089 4.511 3.272 0 1.279-.624 2.272-1.875 2.974l3.222 4.822h-3.39l-2.347-4.027h-.757zm11.484-2.376c-.434 0-.737.155-.911.465-.173.31-.27.769-.285 1.379v.237c0 .734.1 1.268.295 1.597.197.328.508.49.933.49a.871.871 0 00.825-.487c.17-.325.256-.864.256-1.616 0-.736-.087-1.265-.256-1.585-.173-.321-.458-.48-.857-.48m.992 6.554c-.432 0-.821-.071-1.165-.215-.346-.143-.685-.4-1.023-.777h-.139c.094.601.139.976.139 1.123v3.443h-2.96V24.167h2.408l.415 1.091h.137c.55-.826 1.31-1.241 2.278-1.241.95 0 1.693.392 2.233 1.179.54.788.812 1.87.812 3.242 0 1.383-.282 2.472-.847 3.267-.56.793-1.324 1.193-2.288 1.193",
  fill: "url(#angsuran_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.634 6.667a1.366 1.366 0 01.202 2.717l-.202.015h-1.271V13.3a1.366 1.366 0 01-2.717.201l-.015-.201V9.399h-1.265a1.366 1.366 0 01-.202-2.718l.202-.014h5.268z",
  fill: "url(#angsuran_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.79 13.486a10.002 10.002 0 1110.076 17.281 10.002 10.002 0 01-10.077-17.28z",
  fill: "url(#angsuran_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.16 22.257a1.664 1.664 0 113.33-.003 1.664 1.664 0 01-3.33.003",
  fill: "#FFC9AF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDBA15",
  fillRule: "nonzero",
  d: "M30.492 14.59v4.999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.825 16.393c.434 0 .793.32.855.736l.01.128v4.999a.864.864 0 01-1.72.127l-.01-.127v-4.999c0-.477.388-.864.865-.864z",
  fill: "#FFC9AF"
}));

function SvgAngsuran(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgAngsuran;